const endpoints = {
    signup: '/users/signUp',
    signin: '/users/login',
    depositNft: '/users/depositNft',
    userProfile: '/users/getProfile',
    getNft: '/api/getNft',
    depositEth: '/api/depositEth',
    putOnSale: '/api/putOnsale',
    cancelPutOnSell: '/api/cancelPutOnSell',
    getMarketNft: '/api/getMarketNft',
    getProfileById: '/users/getProfileById',
    buyNft: '/api/buy',
    withdrawNft: '/api/withdraw',
};

export { endpoints };
